<script setup>
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
//import axios from "axios";

const store = useStore()

onMounted( ()=>{
  init()
})

const init = async () => {
  store.commit('menuModule/initMenu')

  // для сертификатов добавлен раздел Сообщения
  // user.value.type = 3
  // обработка будет в dialogue.php

}
const user = computed( () => {return store.getters['authModule/user']})
</script>

<template>
  <main class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col"><h3>Мой профиль</h3></div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">


        <div class="row">

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">ФИО</div>
              <div class="card-body text-center"><h5>{{ user['name'] }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-success">
              <div class="card-header text-center">Номер телефона</div>
              <div class="card-body text-center"><h5>{{ user['phone'] }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-danger">
              <div class="card-header text-center">E-mail</div>
              <div class="card-body text-center"><h5>{{ user['email'] }}</h5></div>
            </div>
          </div>

        </div>

      </div>
    </section>


  </main>
</template>
<style scoped>
</style>